// extracted by mini-css-extract-plugin
export default {"container":"WagerBonus_container--fUV","wagerPercentage":"WagerBonus_wagerPercentage--Mmv","bonusName":"WagerBonus_bonusName--fy6"};